import { Divider } from '@mui/material';

import { ThemeStatusToBgColorMappingObj } from 'enrollment/app/constants';
import {
  DocumentRequest,
  DocumentTypeDto,
} from 'enrollment/features/ToDoList/types';
import { RequestedDocuments } from './RequestedDocuments';
import { UploadedDocuments } from './UploadedDocuments';

// eslint-disable-next-line
interface mulitpleDocProps {
  status: string;
  document_type_id: number;
  status_label?: string;
  id?: number;
  bgColor?: string;
  borderColor?: string;
}

interface AddDependentIQCardDetailsType {
  cardName: string;
  cardDetails: DocumentRequest;
  docTypes: DocumentTypeDto[];
}

export const AddDependentIQCardDetails = ({
  cardName,
  cardDetails,
  docTypes,
}: AddDependentIQCardDetailsType) => {
  let multipleDocuments: mulitpleDocProps[] = [];
  let missingDocTypes: string[] = [];

  const statusValue = cardDetails.status_label;
  let backgroundColors = ThemeStatusToBgColorMappingObj(statusValue)?.bgColor;
  let borderColors = ThemeStatusToBgColorMappingObj(statusValue)?.borderColor;

  // historic doc requests
  // multple doc requirements?
  const totalReqDocs =
    cardDetails.number_of_documents_required +
    cardDetails.number_of_secondary_documents_required;
  let numRequiredDocRequests = totalReqDocs;

  // takes all requeired document types
  missingDocTypes = [
    ...cardDetails.org_subscriber_document_type_ids,
    ...cardDetails.org_subscriber_secondary_document_type_ids,
  ];
  cardDetails.submitted_documents.forEach((doc) => {
    if (['iq_needs_review', 'needs_review', 'submitted'].includes(doc.status)) {
      numRequiredDocRequests -= 1;

      backgroundColors = ThemeStatusToBgColorMappingObj(
        cardDetails.status_label
      )?.bgColor;
      borderColors = ThemeStatusToBgColorMappingObj(
        cardDetails.status_label
      )?.borderColor;

      const request = {
        id: doc.id,
        status: doc.status,
        status_label: cardDetails.status_label,
        bgColor: backgroundColors,
        borderColor: borderColors,
        document_type_id: doc.document_type_id,
      };

      multipleDocuments = [...multipleDocuments, request];
      missingDocTypes = missingDocTypes.filter(
        (num) => Number(num) !== doc.document_type_id
      );
    } else if (['approved', 'iq_approved'].includes(doc.status)) {
      numRequiredDocRequests -= 1;

      backgroundColors = ThemeStatusToBgColorMappingObj(
        doc.status_label
      )?.bgColor;
      borderColors = ThemeStatusToBgColorMappingObj(
        doc.status_label
      )?.borderColor;

      const request = {
        id: doc.id,
        status: doc.status,
        status_label: doc.status_label,
        bgColor: backgroundColors,
        borderColor: borderColors,
        document_type_id: doc.document_type_id,
      };

      multipleDocuments = [...multipleDocuments, request];
      missingDocTypes = missingDocTypes.filter(
        (num) => Number(num) !== doc.document_type_id
      );
    }
    // handle rejected and reissued as well as removed
  });

  // adds the not yet submitted doc requests
  for (let i = 0; i < numRequiredDocRequests; i++) {
    const request = {
      status: 'requested',
      document_type_id: 0,
    };
    multipleDocuments = [request, ...multipleDocuments];
  }

  return (
    <div key={cardDetails.id}>
      {multipleDocuments.length >= 1 &&
        multipleDocuments.map((doc, index) => {
          return (
            <>
              {index > 0 && <Divider />}
              {doc.status === 'requested' ? (
                <RequestedDocuments
                  cardName={cardName}
                  cardDetails={cardDetails}
                  missingDocTypes={missingDocTypes}
                />
              ) : (
                <UploadedDocuments
                  imageId={doc.id}
                  cardName={cardName}
                  cardDetails={cardDetails}
                  docTypes={docTypes}
                  submittedDocType={Number(doc.document_type_id)}
                  backgroundColor={doc.bgColor}
                  borderColor={doc.borderColor}
                  label={doc.status_label}
                />
              )}
            </>
          );
        })}
    </div>
  );
};
